import { SeoHead } from "@/components/landing/SeoHead";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { ConceptSection } from "@/components/landing/ConceptSection";
import { RisksBenefits } from "@/components/landing/RisksBenefits";
import { ProcessTimeline } from "@/components/landing/ProcessTimeline";
import { ServicesSection } from "@/components/landing/ServicesSection";
import { TargetGroups } from "@/components/landing/TargetGroups";
import { CoverageSection } from "@/components/landing/CoverageSection";
import { TrustSection } from "@/components/landing/TrustSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <>
      <SeoHead />
      <Header />
      <main data-testid="landing-main">
        <Hero />
        <ConceptSection />
        <RisksBenefits />
        <ProcessTimeline />
        <ServicesSection />
        <TargetGroups />
        <CoverageSection />
        <TrustSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
